module.exports = __webpack_public_path__ + "static/img/7.6d17295.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/zh/7.png
// module id = 0k0e
// module chunks = 0